import { useState} from 'react';

function usePageLoading() {
    const [isPageLoading, setIsPageLoading] = useState(false)
    return {isPageLoading, setIsPageLoading}
};

export default usePageLoading;